module.exports = __webpack_public_path__ + "assets/img/square.339ef206.svg";